"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileInputContent = void 0;
exports.FileInputContent = {
  en: {
    dropFile: "Drop the file here or",
    clickSelect: "click to select",
    required: "Required",
    minFiles: "At least %minFiles% required",
    maxFiles: "No more than %maxFiles% are allowed",
    allowedTypes: "Allowed file types: %allowedTypes%",
    maxSize: "You can select up to %maxSize% bytes of combined file size",
    uploadedFiles: "Uploaded File(s)",
    filesLeft: "Add up to %filesLeft% more file(s)",
    invalidFileType: "Invalid file type was not added",
    partialMax: "Max files of %maxFiles% reached. Not all files were added."
  },
  fr: {
    dropFile: "Déposez le fichier ici ou",
    clickSelect: "cliquez pour sélectionner",
    required: "Obligatoire",
    minFiles: "Au moins %minFiles% obligatoire",
    maxFiles: "Pas plus que %maxFiles% sont autorisés",
    allowedTypes: "Types de fichiers autorisés: %allowedTypes%",
    maxSize: "Vous pouvez sélectionner jusqu'à %maxSize% octets de taille de fichier combinée",
    uploadedFiles: "Fichier(s) téléchargé(s)",
    filesLeft: "Add up to %filesLeft% plus de fichier(s)",
    invalidFileType: "Le type de fichier non valide n'a pas été ajouté",
    partialMax: "Fichiers maximum de %maxFiles% atteint. Tous les fichiers n'ont pas été ajoutés."
  },
  es: {
    dropFile: "Suelte el archivo aquí o",
    clickSelect: "clic para seleccionar",
    required: "Requerido",
    minFiles: "Al menos %minFiles% requerido",
    maxFiles: "No más que %maxFiles% están permitidos",
    allowedTypes: "Tipos de archivo permitidos: %allowedTypes%",
    maxSize: "Puede seleccionar hasta %maxSize% bytes de tamaño de archivo combinado",
    uploadedFiles: "Archivos subidos",
    filesLeft: "Add up to %filesLeft% more file(s)",
    invalidFileType: "No se agregó un tipo de archivo no válido",
    partialMax: "Max archivos de %maxFiles% alcanzó. No se agregaron todos los archivos.."
  }
};